/* 🤖 this file was generated by svg-to-ts */
export const siriusFacebookLogoDuotone: {
  name: 'facebook_logo_duotone';
  data: string;
} = {
  name: 'facebook_logo_duotone',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" style="display: block;"><path opacity=".2" d="M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18Z" fill="currentColor"/><path fill-rule="evenodd" clip-rule="evenodd" d="M2.25 12c0 5.383 4.362 9.747 9.744 9.75h.012c5.382-.003 9.744-4.367 9.744-9.75 0-5.385-4.365-9.75-9.75-9.75S2.25 6.615 2.25 12ZM12 3.75a8.25 8.25 0 0 0-.75 16.466V14.25H9a.75.75 0 0 1 0-1.5h2.25v-2.248A2.99 2.99 0 0 1 14.252 7.5h1.498a.75.75 0 0 1 0 1.5h-1.503a1.49 1.49 0 0 0-1.497 1.497v2.253H15a.75.75 0 0 1 0 1.5h-2.25v5.966A8.251 8.251 0 0 0 12 3.75Z" fill="currentColor"/></svg>`
};
